import React from "react";
import styled from "styled-components";
import VideoStreamItem from "./VideoStreamItem";
import Wrapper from "../atoms/Wrapper";
import InfiniteScroll from "./InfiniteScroll";
import CircularProgress from "@material-ui/core/CircularProgress";
import VideoStreamItemAd from "../organisms/VideoStreamItemAd";

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 5px;
  ${(props) => (props.left ? "" : "justify-content: center;")}
`;

const Message = styled(Wrapper)`
  padding-top: 1rem;
  padding-left: 0.6rem;
  color: ${(props) => props.theme.colors.gray};
`;

const VideoStream = (props) => {
  return (
    <StyledWrapper>
      {props.requestState === "failure" ? (
        <Message>読み込みに失敗しました</Message>
      ) : (
        <InfiniteScroll
          pageStart={0}
          loadMore={props.loadMore}
          hasMore={props.hasMore}
          initialLoad
          loader={<CircularProgress key="vtuber_stream_loading" />}
          requestState={props.requestState}
          page={props.page}
        >
          {props.items.map((item, idx) => {
            if (props.ad && (idx + 1) % 6 === 0) {
              return (
                <>
                  <VideoStreamItemAd
                    key={`video_ad_${idx}`}
                    type={props.adType}
                  />
                  <VideoStreamItem item={item} key={idx} />
                </>
              );
            }
            return <VideoStreamItem item={item} key={idx} />;
          })}
        </InfiniteScroll>
      )}
    </StyledWrapper>
  );
};

export default VideoStream;
